import SupervisorAccountOutlined from '@mui/icons-material/SupervisorAccountOutlined';
import { Box, ButtonBase, Paper, Typography } from '@mui/material';
import { useSelector } from 'react-redux';

import { storage } from '@/services/storage';
import { useStorageValue } from '@/services/storage/react';
import type { RootState } from '@/store';
import { redirectTo } from '@/utils/navigation';

const exitImpostorMode = () => {
  const cached = storage.get('auth.cachedToken');
  if (storage.get('auth.gxToken') && cached) {
    storage.set('auth.gxToken', cached);
    storage.remove('auth.tripToken');
    storage.remove('auth.cachedToken');
    storage.remove('auth.impersonator');
  }
};

export const ImpersonatorBanner = () => {
  const handleExitImpersonatorMode = () => {
    exitImpostorMode();
    redirectTo('/');
  };
  const impersonatorEmail = useStorageValue('auth.impersonator');

  const tripTokenState = useSelector((state: RootState) => state.tripToken);

  if (!impersonatorEmail) return null;
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        width: '100%',
        gap: 3
      }}
    >
      <Paper
        sx={{
          width: '100%',
          height: '48px',
          backgroundColor: 'gx.highlight',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          px: 2,
          mb: 3
        }}
      >
        <Typography>
          You are logged in as <span style={{ fontWeight: 700 }}>{tripTokenState.userEmail}</span>
        </Typography>
        <ButtonBase
          sx={{
            width: 120,
            height: 32,
            ml: 3,
            px: 1,
            backgroundColor: 'gx.actionBarButtonTile',
            fontSize: 12
          }}
          onClick={handleExitImpersonatorMode}
        >
          <SupervisorAccountOutlined sx={{ fontSize: 18, mr: 0.5 }} /> Switch back
        </ButtonBase>
      </Paper>
    </Box>
  );
};
